export default __webpack_public_path__ + "static/media/idf-redstar.ca0a1281.png";